import React from 'react';
import bem from 'utils/bem';
import Text from 'components/Text';

import './index.sass';

const { block } = bem('form-error');

const FormError = ({ children }) => {
    return (
        <div className={ block() }>
            { children }
        </div>
    )
}

export default FormError;
